/*
*
* File JS per la Single Magazine
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper, { Navigation, Pagination, Grid } from 'swiper';
Swiper.use([Navigation, Pagination, Grid]);

//--------------------------------------------------------------------//

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import image from 'imComponents/image/image';
import card25 from 'components/cards/card-25';
import carouselGallery from 'imComponents/carousel-gallery/carousel-gallery';
import blockVideo from 'imComponents/block-video/block-video';
import blockEmbed from 'imComponents/block-embed/block-embed';
import blockText from 'components/block-text/block-text';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './single-magazine.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

carouselGallery();
blockVideo();

//--------------------------------------------------------------------//


// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//

const initSwiperRelated = () => {
    let sliderRelated = document.querySelector('.block-related .swiper-container');
    
    if(!sliderRelated) return;

    let swiper = [];
    let initialized = false;

    const initSwipers = () => {
        let args = {
            spaceBetween: 40,
            breakpoints: {
                0: {
                    slidesPerView: 1.3,
                },
                768: {
                    slidesPerView: 2.5,
                },
                1024: {
                    slidesPerView: 4,
                }
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };
    
        swiper = new Swiper(sliderRelated, args);

        initialized = true;
    };

    initSwipers();
}
initSwiperRelated();

//--------------------------------------------------------------------//